/** ShaffofQurilish belgisi — inline SVG (tashqi fayl kerak emas). */
export const SHAFFOF_LOGO_SVG = `<svg class="shaffof-id-btn__logo" viewBox="0 0 26 26" fill="currentColor" aria-hidden="true" focusable="false">
  <path d="M4.47154 0.662628H0.662598V4.47157H4.47154V0.662628Z"/>
  <path d="M25.3374 0.662628H21.5284V4.47157H25.3374V0.662628Z"/>
  <path d="M21.6862 10.4307L15.5648 4.3138V0H10.4307V4.3138L4.3138 10.4307H0V15.5648H5.13419V11.251L11.251 5.13419H14.7445L20.8658 11.251V15.5648H26V10.4307H21.6862Z"/>
  <path d="M15.5649 20.8658H10.4307V26H15.5649V20.8658Z"/>
  <path d="M15.5648 14.7444V10.4306H10.4306V14.7444L3.65116 21.5284H0.662598V25.3374H4.47154V22.3488L11.251 15.5648H14.7444L21.5284 22.3488V25.3374H25.3374V21.5284H22.3488L15.5648 14.7444Z"/>
</svg>`

export const LABELS = {
  uz: 'Shaffof ID orqali kirish',
  ru: 'Войти через Shaffof ID',
  en: 'Sign in with Shaffof ID',
} as const

export type Locale = keyof typeof LABELS
